import type { CargaToolbarProps } from "./types-carga-toolbar";
import { useCargaToolbar } from "./use-carga-toolbar";
import { CargaToolbarView } from "./view-carga-toolbar";

export function CargaToolbar(props: CargaToolbarProps) {
  const vm = useCargaToolbar(props);

  return <CargaToolbarView {...vm} />;
}

export type * from "./types-carga-toolbar";
